"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_utilities_1 = require("@syl-editor/core-utilities");
var NAME = 'header1';
var Header1 = /** @class */ (function (_super) {
    __extends(Header1, _super);
    function Header1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.tagName = function () { return 'h1'; };
        _this.textMatcher = [
            {
                matcher: /^(#{1})\s$/,
                handler: function (match) {
                    return {
                        level: match[1].length
                    };
                }
            }
        ];
        _this.attrs = {
            level: {
                default: 1
            }
        };
        _this.parseDOM = [{ tag: 'h1', attrs: { level: 1 } }];
        return _this;
    }
    return Header1;
}(core_utilities_1.Block));
exports.Header1 = Header1;
var Header1Controller = /** @class */ (function (_super) {
    __extends(Header1Controller, _super);
    function Header1Controller() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.toolbar = {
            className: 'header1',
            tooltip: 'header1'
        };
        return _this;
    }
    return Header1Controller;
}(core_utilities_1.SylController));
exports.Header1Controller = Header1Controller;
var Header1Plugin = /** @class */ (function (_super) {
    __extends(Header1Plugin, _super);
    function Header1Plugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.Controller = Header1Controller;
        _this.Schema = Header1;
        return _this;
    }
    return Header1Plugin;
}(core_utilities_1.SylPlugin));
exports.Header1Plugin = Header1Plugin;
//# sourceMappingURL=header1.js.map